// dbAxionRemediationTrigger is free-text written by the AI risk-analysis pipeline with no
// fixed format: some risks get "(1) ... (2) ... (3) ...", others "(a) ... (b) ... (c) ...",
// and others no marker at all. Every risk-list page renders this field, so the parsing lives
// here once instead of being reimplemented per page (previously: 8 pages rendered it as one
// flat paragraph with no parsing at all, and AllRisks.js parsed only the digit-marker style
// and then discarded the numbers instead of redisplaying them).
const MARKER_PATTERNS = [
  /\(\d+\)\s[^]+?(?=\s\(\d+\)\s|$)/g, // (1) ... (2) ... (3) ...
  /\([a-z]\)\s[^]+?(?=\s\([a-z]\)\s|$)/gi, // (a) ... (b) ... (c) ...
];

// Returns { intro, items }. `items` is an array of condition strings with their original
// marker stripped (the caller renders its own numbering) when a marker-delimited list is
// found; otherwise `items` is null and the caller should render `trigger` as plain text —
// splitting unmarked prose on commas/periods is unreliable (conditions themselves contain
// internal commas, e.g. "hosts privileged tooling (CI/CD agents, secrets managers, ...)").
export function parseRemediationTrigger(trigger) {
  if (!trigger) return { intro: null, items: null };

  for (const pattern of MARKER_PATTERNS) {
    const matches = trigger.match(pattern);
    if (matches && matches.length > 1) {
      const firstIdx = trigger.indexOf(matches[0]);
      const intro = firstIdx > 0 ? trigger.slice(0, firstIdx).trim() : null;
      const items = matches.map((item) =>
        item
          .replace(/^\([\da-z]+\)\s*/i, '')
          .replace(/[,;]?\s*(or|and)?\s*$/i, '')
          .trim()
      );
      return { intro, items };
    }
  }

  return { intro: null, items: null };
}
